import React from 'react';
import App from './../app.jsx';
import { Navigate } from 'react-router-dom';

import Dashboard from './../pages/dashboard/dashboard.js';
import AIChatbot from './../pages/aichatbot/aichatbot.js';
import AINotes from '../pages/admin/ainotes.tsx';
import AIVoiceProspect from './../pages/aivoiceprospect/aivoiceprospect.js';
import ArtemisAI from './../pages/artemis/artemis.js';
import CRM from './../pages/crm/crm.js';
import Dealership from './../pages/aichatbot/Dealership.js';
import DealerFiles from './../pages/loanverification/dealerfiles.js';
import DealerFileDetails from './../pages/loanverification/dealerfiledetails.js';
import DealerFileUpload from './../pages/loanverification/dealerfileupload.js';
import DealerRehash from './../pages/dealerrehash/Rehash.js';
import RedFlagAI from './../pages/redflagai/redflagai.js';
// import TracirBureauData from './../pages/tracir/bureaudata.tsx';
import AIQueryAgent from './../pages/aiqueryagent/aiqueryagent.js';

import AIBreaker from './../pages/games/aibreaker/AIBreaker.js';
import CaptainPaws from './../pages/games/captainpaws/CaptainPaws.js';

import Analytics from './../pages/analytics/analytics.js';
import EmailInbox from './../pages/email/inbox.js';
import EmailCompose from './../pages/email/compose.js';
import EmailDetail from './../pages/email/detail.js';
import Widgets from './../pages/widgets/widgets.js';
import PosCustomerOrder from './../pages/pos/customer-order.js';
import PosKitchenOrder from './../pages/pos/kitchen-order.js';
import PosCounterCheckout from './../pages/pos/counter-checkout.js';
import PosTableBooking from './../pages/pos/table-booking.js';
import PosMenuStock from './../pages/pos/menu-stock.js';
import UiBootstrap from './../pages/ui/bootstrap.js';
import UiButtons from './../pages/ui/buttons.js';
import UiCard from './../pages/ui/card.js';
import UiIcons from './../pages/ui/icons.js';
import UiModalNotifications from './../pages/ui/modal-notifications.js';
import UiTypography from './../pages/ui/typography.js';
import UiTabsAccordions from './../pages/ui/tabs-accordions.js';
import FormElements from './../pages/form/elements.js';
import FormPlugins from './../pages/form/plugins.js';
import FormWizards from './../pages/form/wizards.js';
import TableElements from './../pages/table/elements.js';
import TablePlugins from './../pages/table/plugins.js';
import ChartJs from './../pages/charts/js.js';
import ChartApex from './../pages/charts/apex.js';
import Map from './../pages/map/map.js';
import LayoutStarter from './../pages/layout/starter.js';
import LayoutFixedFooter from './../pages/layout/fixed-footer.js';
import LayoutFullHeight from './../pages/layout/full-height.js';
import LayoutFullWidth from './../pages/layout/full-width.js';
import LayoutBoxedLayout from './../pages/layout/boxed-layout.js';
import LayoutCollapsedSidebar from './../pages/layout/collapsed-sidebar.js';
import LayoutTopNav from './../pages/layout/top-nav.js';
import LayoutMixedNav from './../pages/layout/mixed-nav.js';
import LayoutMixedNavBoxedLayout from './../pages/layout/mixed-nav-boxed-layout.js';
import PagesScrumBoard from './../pages/pages/scrum-board.js';
import PagesProducts from './../pages/pages/products.js';
import PagesProductDetails from './../pages/pages/product-details.js';
import PagesOrders from './../pages/pages/orders.js';
import PagesOrderDetails from './../pages/pages/order-details.js';
import PagesGallery from './../pages/pages/gallery.js';
import PagesSearchResults from './../pages/pages/search-results.js';
import PagesComingSoon from './../pages/pages/coming-soon.js';
import PagesError from './../pages/pages/error.js';
import PagesLogin from './../pages/pages/login.js';
import PagesLogout from './../pages/pages/logout.js';
import PagesRegister from './../pages/pages/register.js';
import PagesMessenger from './../pages/pages/messenger.js';
import PagesDataManagement from './../pages/pages/data-management.js';
import PagesFileManager from './../pages/pages/file-manager.js';
import PagesPricing from './../pages/pages/pricing.js';
import Perplexed from './../pages/pages/perplexed.js';
import Profile from './../pages/profile/profile.js';
import Calendar from './../pages/calendar/calendar.js';
import Settings from './../pages/settings/settings.js';
import Helper from './../pages/helper/helper.js';
import CenterPhilMontessori from './../pages/centerphilmontessori/CenterPhilMontessori.js';

const teamId = localStorage.getItem('team_id');
const isAdmin = teamId === 'gale-force-ai-01-14478acd';
const isAmericanFinance = teamId === 'american-finance-01-41f43c80';
const isTracir = teamId === 'tracir-01-6f42ee20';


const RedirectToExternalUrl = ({ url }) => {
	window.location.href = url;
	return null;
};

const AppRoute = [
  {
    path: '*', 
    element: <App />,
    children: [
    	{ path: '', element: <Navigate to={
			isAdmin ? '/aicrm'
			: isAmericanFinance ? '/loanverification/dealerfiles'
			: isTracir ? '/aiqueryagent'
			: '/login'
		} /> },
		{ path: 'chat/:topic', element: <AIChatbot /> },
		{ path: 'aivoiceprospect', element: <AIVoiceProspect /> },
		{ path: 'artemisai', element: <ArtemisAI /> },
		{ path: 'aicrm', element: <CRM /> },
		{ path: 'dealerrehash', element: <DealerRehash /> },
		{ path: 'dealerrehash/:appNum', element: <DealerRehash /> },
		{ path: 'dealership', element: <Dealership /> },
		{ path: 'dealership/:topic', element: <Dealership /> },
		{ path: 'loanverification/dealerfiles', element: <DealerFiles /> },
		{ path: 'loanverification/dealerfiles/:fileId', element: <DealerFileDetails /> },
		{ path: 'loanverification/dealerfileupload', element: <DealerFileUpload /> },
		{ path: 'redflagai', element: <RedFlagAI /> },
		// { path: 'tracir/bureaudata', element: <TracirBureauData /> },
		{ path: 'aiqueryagent', element: <AIQueryAgent /> },
		
		{ path: 'login', element: <PagesLogin /> },
		{ path: 'logout', element: <PagesLogout /> },
		{ path: 'signup', element: <PagesRegister /> },
		{ path: 'ainotes', element: <AINotes /> },
		{ path: 'dashboard', element: <Dashboard /> },
		// { path: 'callmentorai', element: <CallMentorAI /> },

		{ path: 'games/aibreaker', element: <AIBreaker /> },
		{ path: 'games/captainpaws', element: <CaptainPaws /> },

    	{ path: 'analytics', element: <Analytics /> },
    	{ path: 'email/*', 
    		children: [
					{ path: 'inbox', element: <EmailInbox /> },
					{ path: 'compose', element: <EmailCompose /> },
					{ path: 'detail', element: <EmailDetail /> }
				]
			},
    	{ path: 'widgets', element: <Widgets /> },
    	{ path: 'pos/*', 
    		children: [
					{ path: 'customer-order', element: <PosCustomerOrder /> },
					{ path: 'kitchen-order', element: <PosKitchenOrder /> },
					{ path: 'counter-checkout', element: <PosCounterCheckout /> },
					{ path: 'table-booking', element: <PosTableBooking /> },
					{ path: 'menu-stock', element: <PosMenuStock /> }
				]
			},
    	{ path: 'ui/*', 
    		children: [
					{ path: 'bootstrap', element: <UiBootstrap /> },
					{ path: 'buttons', element: <UiButtons /> },
					{ path: 'card', element: <UiCard /> },
					{ path: 'icons', element: <UiIcons /> },
					{ path: 'modal-notifications', element: <UiModalNotifications /> },
					{ path: 'typography', element: <UiTypography /> },
					{ path: 'tabs-accordions', element: <UiTabsAccordions /> },
				]
			},
    	{ path: 'form/*', 
    		children: [
					{ path: 'elements', element: <FormElements /> },
					{ path: 'plugins', element: <FormPlugins /> },
					{ path: 'wizards', element: <FormWizards /> }
				]
			},
    	{ path: 'table/*', 
    		children: [
					{ path: 'elements', element: <TableElements /> },
					{ path: 'plugins', element: <TablePlugins /> }
				]
			},
    	{ path: 'chart/*', 
    		children: [
					{ path: 'chart-js', element: <ChartJs /> },
					{ path: 'chart-apex', element: <ChartApex /> }
				]
			},
    	{ path: 'layout/*', 
    		children: [
					{ path: 'starter-page', element: <LayoutStarter /> },
					{ path: 'fixed-footer', element: <LayoutFixedFooter /> },
					{ path: 'full-height', element: <LayoutFullHeight /> },
					{ path: 'full-width', element: <LayoutFullWidth /> },
					{ path: 'boxed-layout', element: <LayoutBoxedLayout /> },
					{ path: 'collapsed-sidebar', element: <LayoutCollapsedSidebar /> },
					{ path: 'top-nav', element: <LayoutTopNav /> },
					{ path: 'mixed-nav', element: <LayoutMixedNav /> },
					{ path: 'mixed-nav-boxed-layout', element: <LayoutMixedNavBoxedLayout /> }
				]
			},
    	{ path: 'pages/*', 
    		children: [
					{ path: 'scrum-board', element: <PagesScrumBoard /> },
					{ path: 'products', element: <PagesProducts /> },
					{ path: 'product-details', element: <PagesProductDetails /> },
					{ path: 'orders', element: <PagesOrders /> },
					{ path: 'order-details', element: <PagesOrderDetails /> },
					{ path: 'gallery', element: <PagesGallery /> },
					{ path: 'search-results', element: <PagesSearchResults /> },
					{ path: 'coming-soon', element: <PagesComingSoon /> },
					{ path: 'error', element: <PagesError /> },
					{ path: 'login', element: <PagesLogin /> },
					{ path: 'logout', element: <PagesLogout /> },
					{ path: 'register', element: <PagesRegister /> },
					{ path: 'messenger', element: <PagesMessenger /> },
					{ path: 'data-management', element: <PagesDataManagement /> },
					{ path: 'file-manager', element: <PagesFileManager /> },
					{ path: 'pricing', element: <PagesPricing /> }
				]
			},
		{ path: 'map', element: <Map /> },
    	{ path: 'profile', element: <Profile /> },
    	{ path: 'calendar', element: <Calendar /> },
    	{ path: 'settings', element: <Settings /> },
    	{ path: 'helper', element: <Helper /> },
		
		{ path: 'salesaiagents', element: <Navigate to="/aicrm" replace /> },
		{ path: 'prompt-engineering-mastery', element: <Navigate to="/chat/promptengineeringmastery" replace /> },
		{ path: 'what-generative-ai-can-do-for-you', element: <Navigate to="/chat/thebusinessshowmarch2024" replace /> },
		{ path: 'centerphilmontessori', element: <CenterPhilMontessori /> },
		{ path: 'centerphilmontessori/pfa/bylaws', element: <RedirectToExternalUrl url="https://galeforceai-public.s3.us-east-2.amazonaws.com/centerphilmontessori/CenterPhil_Montessori_PFA_Bylaws_v2.pdf" /> },
    	{ path: '*', element: <Perplexed /> }
		]
    }
];

export default AppRoute;